import Axios from './caller.service';

let creerVoyage = (message, currentTrip, previousMessage) => {
    return Axios.post('/ai/chat', message, currentTrip, previousMessage);
  }

  export type PlannerAIAction =
  | "ADD_ACTIVITIES"
  | "FIX_TRANSPORTS"
  | "CHECK_ITINERARY"
  | "REBALANCE_NIGHTS"
  | "ASK_QUESTION";

export const aiService = {
  assistantPlanificateur: (
  action: PlannerAIAction,
  idVoyage: string | number,
  userMessage: string = "",
  selectedDay: number | null = null,
  conversationHistory: { role: "user" | "assistant"; content: string }[] = []
  ) => {
    return Axios.post("/ai/assistant-planificateur", {
      action,
      idVoyage,
      selectedDay,
      userMessage,
      conversationHistory,
    });
  },
  applyPlannerActions: (
    idVoyage: string | number,
    actions: any[]
  ) => {
    return Axios.post("/ai/assistant-planificateur/apply-actions", {
      idVoyage,
      actions,
    });
},
};



export const iaService = {
    creerVoyage,
    aiService
  }